import { Box, Button, debounce, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from "@mui/material"
import { useAppSelector } from "../../../../../../../../hooks/store-hooks"
import { useListaCEPService } from "../../../../../../../../../use-cases/geo-veles"

export const CreateListaCEPForm = (props: {
    openForm: boolean
}) => {
    // State
    const { listaCEP } = useAppSelector((state) => state)
    // Hook
    const {
        openCreateListaCEPForm,
        setCreateListaCEPName,
        createListaCEP
    } = useListaCEPService()

    return (
        <>
            {
                props.openForm === true &&
                <Dialog
                    fullWidth
                    maxWidth="md"
                    open={listaCEP.openCreateListaCEP}
                    onClose={() => {
                        openCreateListaCEPForm(false)
                    }}
                >
                    <DialogTitle>
                        Criar nova lista de CEPs
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Escolha um nome para a lista de CEPs
                        </DialogContentText>
                        <Box my={3}>
                            <TextField
                                error={Boolean(listaCEP.createListaCEPForm.touched && listaCEP.createListaCEPForm.errors.find(item => item.key === 'nome'))}
                                helperText={listaCEP.createListaCEPForm.errors.find((error) => error.key === 'nome')?.message}
                                defaultValue={listaCEP.createListaCEPForm.fields.nome}
                                onChange={debounce((e) => {
                                    setCreateListaCEPName(e.target.value)
                                }, 500)}
                                autoFocus
                                id="nomeproj"
                                label="Digite o nome da lista de CEPs"
                                fullWidth
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                openCreateListaCEPForm(false)
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={() => {
                                createListaCEP()
                            }}
                        >
                            Criar
                        </Button>
                    </DialogActions>
                </Dialog>
            }
        </>
    )
}